import styled, { css } from 'styled-components'
import Slider from 'react-slick'

export const Wrapper = styled.div`
  margin: 5px auto;

  padding: 1px 10px 10px;
  // background: #0d1320;

  width: 100%;

  @media (min-width: 729px) {
    width: 90%;
  }

  @media (min-width: 1500px) {
    width: 1270px;
  }

  .marquee-container {
    width: 100%;
  }
`

export const Notice = styled.div`
  width: 100%;
  height: 51px;
  padding: 5px;
  border-radius: 24px;
  border: 0.2px solid rgb(209, 175, 132);
  background: #80808080;
  box-shadow: rgb(82, 82, 93) 1px 1px 4px -2px inset;
  display: flex;
  align-items: center;
  @media (max-width: 729px) {
    display: none;
  }
  .left {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    .text {
      font-size: 12px;
      color: #fff;
    }
  }
  .right {
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    .marquee {
      height: 25px;
      width: 100%;

      overflow: hidden;
      position: relative;
    }

    .marquee div {
      margin-top: 6px;
      display: block;
      width: 1250px;
      position: absolute;
      overflow: hidden;
      animation: marquee 15s linear infinite;
    }

    .marquee .span {
      float: left;
      width: auto;
      span {
        margin: 0 3px;
      }
      .a1 {
        color: #fe642e;
      }
      .a2 {
        color: #ffff00;
      }
      .a3 {
        color: #fe642e;
      }
      .a4 {
        color: #2e9afe;
      }
      .a5 {
        color: #fe642e;
      }
      .a6 {
        color: #9afe2e;
      }
      .a7 {
        color: #ff4000;
      }
    }

    @keyframes marquee {
      0% {
        left: 100%;
      }
      100% {
        left: -1200px;
      }
    }
  }
`

export const LiveCasino = styled.div`
  width: 100%;
  margin-top: 10px;
  img {
    width: 100%;
  }
  .btn {
    width: 10%;
    cursor: pointer;
    margin: auto;
    display: block;
  }
`

export const SliderContent = styled(Slider)`
  width: 100%;
  /* margin-top: 50px; */
  .item {
    padding: 0 2px;
    img {
      width: 100%;
      border-radius: 2px;
      cursor: pointer;
    }
  }
`

export const ListItemBox = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px;
  .btn {
    width: 10%;
    margin: 20px;
    cursor: pointer;
  }
`

export const ListItem = styled.div`
  width: calc(25% - 7.5px);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    margin: 0px 10px;
  }
  // .btn {
  //   width: 100px;
  //   height: 42px;
  //   position: absolute;
  //   bottom: 0%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   color: #fff;
  //   font-size: 15px;
  //   text-align: center;
  //   padding: 10px;

  //   border: 1px solid #031622;
  //   background: rgb(12 45 68 / 86%);
  //   transition: all 0.5s;
  // }
  .txt {
    position: absolute;
    color: white;
    font-size: 13px;
    font-weight: 600;
    width: 100%;
    bottom: 0;
    padding: 8px;
    text-align: center;
    // height: 10%;
    background: rgba(0, 0, 0, 0.5);
    // transition: all 0.75s;
    opacity: 1;
    margin-top: 100%;
    z-index: 0;
    margin: 0px 10px;
    text-transform: uppercase;

    @media (max-width: 729px) {
      font-size: 11px;
    }
  }
  :hover {
    //   .btn {
    //     color: #000;
    //     background: #fdd343;
    //     transition: all 0.5s;
    //     z-index: 2;
    //   }
    .txt {
      margin-top: 0;
      opacity: 1;
      z-index: 1;
      height: 90%;
      transition: all 0.75s;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

export const TableBox = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  @media (max-width: 511px) {
    flex-direction: column;
  }
  justify-content: space-between;
  padding: 10px 0 20px;
  margin-top: 24px;
  gap: 20px;
`
export const TableItem = styled.div`
  width: 50%;
  display: flex;
  @media (max-width: 511px) {
    width: 100%;
  }
`

export const ArtTop10 = styled.div`
  background-color: #fff;

  .top10-title {
    color: #5c7161;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    span {
      font-family: 'DMSerifDisplay-Regular';
      &.title {
        font-size: 37px;
        line-height: 1.37;
        letter-spacing: 2.05px;
        text-align: center;
      }
      &.subtitle {
        font-size: 41px;
        line-height: 1.35;
        letter-spacing: -0.93px;
        text-align: center;
      }
      @media (max-width: 425px) {
        &.title,
        &.subtitle {
          font-size: 36px;
        }
      }
    }
  }
  .top10-list {
    width: 100%;
    margin-top: 23px;
    display: flex;
    gap: 41px;
    overflow: auto hidden;
    padding-bottom: 50px;
    cursor: grab;

    @media (max-width: 425px) {
      padding-bottom: 22px;
    }
  }

  @media (max-width: 1440px) {
    padding: 52px 15px 69px 100px;
  }

  @media (max-width: 1024px) {
    padding: 52px 15px 69px 15px;
  }

  @media (max-width: 425px) {
    padding: 52px 15px 69px 15px;
  }
`
export const MiniMenuBox = styled.div<{ active?: any }>`
  height: 100px;
  background-color: #5c7161;
  /* display: none; */
  @media screen and (max-width: 1024px) {
    height: 90px;
  }
  /* ${({ active }) =>
    active
      ? css`
          display: block;
        `
      : ''} */
`

export const ArtNewSletter = styled.div`
  width: 100%;
  /* height: 842px; */
  padding: 52px 0px 92px 0px;
  background-color: #f0f1e4;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .newsletter-title {
    text-align: center;

    span {
      &.title {
        font-family: 'DMSerifDisplay-Regular';
        font-size: 41px;
        line-height: 1.37;
        letter-spacing: 2.05px;
        text-align: center;
        color: #5d7160;
        text-transform: uppercase;
      }
      &.subtitle {
        font-family: 'DMSerifDisplay-Regular';
        font-size: 37px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.35;
        letter-spacing: -0.93px;
        text-align: center;
        color: #5d7160;
      }
    }
  }
  .newsletter-list {
    margin: 64px 0px 0px 311px;
    display: flex;
    gap: 41px;
    overflow: auto hidden;
    padding-bottom: 43px;
    cursor: grab;
  }

  @media (max-width: 1440px) {
    padding: 52px 15px 92px 100px;

    .newsletter-list {
      width: 100%;
      margin: 29px 0px 0px 0px;
      padding-bottom: 36px;
    }
  }

  @media (max-width: 1024px) {
    padding: 60px 15px 81px 15px;
  }

  @media (max-width: 425px) {
    width: 100%;
    padding: 60px 15px 81px 15px;
    align-items: center;
    justify-content: center;

    .newsletter-title {
      width: 100%;
      span {
        &.title {
          font-size: 32px;
          letter-spacing: 1.6px;
        }

        &.subtitle {
          font-size: 32px;
          letter-spacing: -0.8px;
        }
      }
    }
  }
`

export const Banner = styled.div`
  position: relative;
  margin-top: -77px;
  img{ 
    width: 100%;
  }
  .num{
   bottom: 39%;
    right: 13%;
    position: absolute;
    font-size: 3em;
    color: #000;
    font-weight: 900;
    @media (max-width: 1024px) {
      font-size: 2em;
    }
    @media (max-width: 425px) {
      font-size: 1em;
     
    }
  }
   @media (max-width: 768px) {
      margin-top: -17px;
     
    }
`
